<template>
  <section class="intro">
    <div class="intro__content" v-if="!inApp">
      <span class="grid-hide"></span>
      <p v-html="$translate('layout').intro" />
    </div>
    <div class="intro__bg" v-else />

    <div :class="[
      'intro__button',
      inApp ? 'intro__button--center' : 'intro__button--bottom'
    ]">
      <AppButton
        :content="$translate('layout').playButton"
        action="startGame"
        :theme="inApp ? 'dark-app' : 'dark'"
      />
    </div>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import { inApp } from '@/scripts/utils';

export default {
  name: 'Intro',

  components: {
    AppButton,
  },

  data() {
    return {
      inApp: inApp(),
    };
  },
};
</script>

<style lang="scss" scoped>
.intro {
  @include grid-game();
  grid-template-rows: repeat(9, 1fr);

  > * {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    position: relative;
    grid-column: 1 / -1;
    grid-row: 2 / 7;

    align-self: center;
    justify-self: center;

    width: calc(100% - 2px);
    height: calc(100% - 2px);
    padding: 0 20px;

    @extend %font-size-m;

    p {
      display: block;
      position: relative;
      width: 100%;
      line-height: inherit;

      font-weight: 300;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-image: url('/img/illustrations/phase-4.jpg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &__button {
    grid-column: 2 / 5;
    grid-row: 8 / 9;

    button {
      min-width: 65%;
      color: $color-red;
    }

    &.intro__button--center {
      grid-row: 8 / 9;
    }
  }

  @include mq(ipadP) {
    &__content {
      grid-column: 4 / 14;
      grid-row: 2 / 7;
      padding: 0 var(--unit-vw);
    }
    &__button {
      grid-column: 7 / 11;
      grid-row: 8 / 9;
    }
  }
}
</style>
